import React, { useEffect, useCallback, useState } from "react";
import CreateReply from "./CreateReply";
import TeamService from "services/TeamService";
import Button from "components/CustomButton";
import Reply from "./Reply";
import Loader from "components/Loader";
import { RepliesContext } from "store/contexts/repliesContext";
import { useExpressionsContext } from "store/contexts/expressionsContext";
import { useLocation } from "react-router-dom";

function RepliesList({ post, expression }) {
  const [replies, setReplies] = useState([]);
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [meta, setMeta] = useState({});
  const location = useLocation();
  const search = location.search;
  const param = new URLSearchParams(search);
  const [reply_id, setReplyId] = useState(param.get("reply_id") ?? null);
  const { updateExpression } = useExpressionsContext();

  useEffect(() => {
    if (reply_id) {
      setReplyId(param.get("reply_id"));
    }
    //eslint-disable-next-line
  }, [search, param]);

  useEffect(() => {
    setIsLoading(true);
    if (reply_id && replies.length !== 0) {
      setReplies([]);
    }

    (async () => {
      try {
        if (!reply_id || reply_id === "undefined") {
          const response = await TeamService.getExpressionList(
            post.team_id,
            post.id,
            { page: page, parent_expression_id: expression?.id }
          );

          setIsLoading(false);
          setMeta(response.data.meta);
          setReplies(Array.from(new Set([...replies, ...response.data.data])));
        }
      } catch (e) {
        console.log(e);
      }
    })();
    //eslint-disable-next-line
  }, [page, reply_id]);

  const createReply = (reply) => {
    // const repliesCopy = replies.slice(0, meta.current_page * 10 - 1);

    // const replyMeta = meta;
    // replyMeta.total += 1;
    // replyMeta.to += 1;

    setReplies(Array.from(new Set([reply, ...replies])));

    // if (replyMeta.total !== 0 && (replyMeta.total - 1) % 10 === 0) {
    //   replyMeta.last_page += 1;
    // }

    setMeta(replyMeta);
  };

  const deleteReply = useCallback(
    (newReply) => {
      var newExpressions = replies.filter(
        (replies) => replies.id !== newReply.id
      );

      const expressionCopy = { ...expression };
      expressionCopy.replies_count -= 1;
      // const replyMeta = meta;
      // replyMeta.total -= 1;

      // if (replyMeta.total !== 0 && (replyMeta.total - 1) % 10 === 0) {
      //   replyMeta.last_page -= 1;
      // }

      // if (replyMeta.total > 10) {
      // }

      // setMeta(replyMeta);
      updateExpression(expressionCopy);

      setReplies(newExpressions);
    },
    [expression, replies, updateExpression]
  );

  const updateReply = (reply) => {
    const repliesCopy = [...replies];

    repliesCopy[
      repliesCopy.findIndex((tReply) => {
        return tReply.id === reply.id;
      })
    ] = {
      ...reply,
    };

    setReplies(repliesCopy);
  };

  return (
    <RepliesContext.Provider
      value={{
        updateReply,
        createReply,
        deleteReply,
      }}
    >
      <div className="post_comments-section">
        <CreateReply post={post} expression={expression} />
        <div>
          {replies.map((reply) => (
            <Reply
              reply={reply}
              key={reply.id}
              post={post}
              disableExpression={true}
            />
          ))}
          {page !== meta?.last_page && !isLoading && !reply_id && (
            <div className="viewAllButton">
              <Button
                buttonClass={"grad_btn join-btn"}
                onClick={() => setPage(page + 1)}
              >
                Load More
              </Button>
            </div>
          )}
          {isLoading && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <Loader />
            </div>
          )}
        </div>
      </div>
    </RepliesContext.Provider>
  );
}

export default RepliesList;
